import { Card, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import SimpleModal from "../../components/common/SimpleModal";
import { toggleBranchModal } from "./redux/branchSlice";
import AddIcon from "../../components/common/AddIcon";
import { useBranchQuery } from "../../graphql/apollo/query-hooks";
import BranchTable from "./components/BranchTable";
import BranchForm from "./components/form/BranchForm";

const BranchPage = () => {
  const dispatch = useDispatch();
  const { isOpenModal } = useSelector((state) => state.branch);
  const { branchList } = useBranchQuery();

  const handleAdd = () => dispatch(toggleBranchModal());
  const handleClose = () => dispatch(toggleBranchModal());

  return (
    <>
      <SimpleModal
        show={isOpenModal}
        handleClose={handleClose}
        title="ຈັດການຈຸສາຂາ"
        size="md"
      >
        <BranchForm handleClose={handleClose} />
      </SimpleModal>
      <Row className="lao">
        <Col lg={12}>
          <Card>
            <Card.Header>
              <Card.Title>
                <h3 className="p-1">ຈັດການຂໍ້ມູນຈຸສາຂາ</h3>
              </Card.Title>
              <AddIcon onClick={handleAdd} />
            </Card.Header>
            <Card.Body>
              <BranchTable data={branchList} />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default BranchPage;
